import { render, staticRenderFns } from "./CartComponent.vue?vue&type=template&id=b6f3635c"
import script from "./CartComponent.vue?vue&type=script&lang=js"
export * from "./CartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports